import { defineTableColumn } from '@core/user-interface-legacy';
import type { AskTicketBoardItem } from '@tellent-ask-hr/core-types';

export enum AsksColumnId {
  RequestName = 'requestName',
  Priority = 'priority',
  Employee = 'employee',
  EmployeeLocation = 'employeeLocation',
  SubmittedAt = 'submittedAt',
  AssignedTo = 'assignedTo',
  Status = 'status',
}

export type AskTableFields =
  | 'id'
  | 'name'
  | 'priority'
  | 'requester'
  // TODO
  | 'employee_location'
  | 'status'
  | 'date_created'
  | 'assignees';

export const defineAskTableColumn = defineTableColumn<AskTicketBoardItem>;

export const askColumnFieldMap: Partial<Record<AsksColumnId, AskTableFields>> = {
  [AsksColumnId.RequestName]: 'name',
  [AsksColumnId.Priority]: 'priority',
  [AsksColumnId.Employee]: 'requester',
  [AsksColumnId.EmployeeLocation]: 'employee_location',
  [AsksColumnId.SubmittedAt]: 'date_created',
  [AsksColumnId.AssignedTo]: 'assignees',
  [AsksColumnId.Status]: 'status',
};
